import {
  CONTACT_REQUEST,
  CONTACT_REQUEST_SUCCESS,
  CONTACT_REQUEST_FAIL
} from 'constants/action-types';

const initialState = {
  error: null,
  showContactComplete: false
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CONTACT_REQUEST:
      return initialState;

    case CONTACT_REQUEST_SUCCESS:
      return {
        ...state,
        showContactComplete: true
      };

    case CONTACT_REQUEST_FAIL:
      return {
        ...state,
        error: action.error.response
      };

    default:
      return initialState;
  }
};



// WEBPACK FOOTER //
// ./src/reducers/contact/index.js